<script setup lang="ts">
import FooterLinks from './FooterLinks.vue';

defineProps<IProps>();
const siteConfigs = useSiteConfigs();
interface IProps {
    isHomePage?: boolean;
    compact?: boolean;
}
</script>

<template>
    <footer id="__footer" class="footer-container shadow-level1">
        <div class="footer-wrapper">
            <FooterLinks :is-home-page :compact :site-configs />
        </div>
    </footer>
</template>

<style lang="scss" scoped>
.footer-container {
    background: white;
    margin-top: 32px;
}

.footer-wrapper {
    width: 85%;
    max-width: $app-container-max-width;
    margin: 0 auto;
}

@media (max-width: $app-tablet-max-width) {
    .footer-wrapper {
        width: 100%;
        padding: 0 24px;
    }
}

@media (max-width: $app-mobile-max-width) {
    .footer-wrapper {
        width: 100%;
        padding: 0 16px;
    }
}
</style>
